import * as React from 'react';
import { FormGroup, Label } from 'reactstrap';

export const TextInput = ({ label, name, input, type, placeholder, id, meta: { touched, error } })   => {

  return (
    <div className="TextField__FieldWrapper">
    <div className={`TextField__LabelWrapper ${touched && error && 'is-invalid'} ${input.value !== '' ? 'selected' : ''}`}>
     <input className={`TextInput ${touched && error && 'is-invalid'}`} placeholder={placeholder || ''} type={type} {...input} id={id} />
     {label !== '' && <Label className="Label__FloatedLabel" htmlFor={id}>{label}</Label>}
     </div>
     {touched && error && 
       // tslint:disable-next-line:max-line-length
       <div className="FieldError__ErrorContainer"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line></svg> {error}</div>}
    </div>
  );
};

export default TextInput;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/_global/components/form-elements/text-input.tsx